import {useRef, useState} from "react";
import {Plus, UploadCloud, Info} from "react-feather"
import {UseRequest} from "../hooks/UseRequest";


import "../libraries/fieldslinker/fieldsLinker.js"
import "../libraries/fieldslinker/fieldsLinker.scss"

import image from "../resources/images/upload.svg"
import {Countries} from "../config/Countries";
import Field from "../modules/form/Field";
import Select from "./input/select";
import {Col, Row} from "react-bootstrap";
import Alert from "./alert";
import Button from "./button";


const Uploader = (props) => {
    const {name, title, subtitle, endpoint, reasons, isReady, onSuccess} = props


    const fileRef = useRef()
    const [files, setFiles] = useState([])

    const [btnReady, setBtnReady] = useState(isReady)
    const [reason, setReason] = useState()
    const [errors, setErrors] = useState({})
    const [country, setCountry] = useState({value: '+34', label: 'Spain'})
    const [infoMessage, setInfoMessage] = useState('The country prefix +34 will be automatically added to the contacts you are trying to upload.')


    const handleFileChoose = (event) => {
        event.preventDefault();
        const selectedFiles = []
        fileRef.current.click()

        Object.keys(fileRef.current.files).forEach((index) => {
            const file = fileRef.current.files[index];
            selectedFiles.push({
                name: file.name,
                type: file.type,
                size: file.size,
            })
        })

        setFiles(selectedFiles)
    }


    const recursiveUpload = (files, iteration = -1) => {
        iteration++

        if (files[iteration] !== undefined) {
            const Data = new FormData()
            Data.append(files[iteration].name, files[iteration])

            if (reason) {
                Data.append('id_action', reason)
            }


            const request = UseRequest(endpoint, {
                    request: {
                        data   : Data,
                        method : 'POST',
                        headers: {'Content-type': null,}
                    }
                }
            );


            request.then(async (response) => {
                const data = await response.json()

                if (response.status >= 200 && response.status < 299) {
                    onSuccess({...data.message, ...{country: country}})
                } else {
                    setErrors(data.errors)
                    setFiles(null)
                }

                setBtnReady(true)


                if (typeof props.afterUpload == "function") {
                    props.afterUpload(data.message.file)
                }

            })

        }
    }


    const handleFileUpload = (event) => {
        event.preventDefault();
        setBtnReady(false)
        recursiveUpload(fileRef.current.files)
    }




    const OptionInfo = {
        icon     : <Info/>,
        title    : 'Important Information',
        className: 'alert-primary mx-3 text-start',
        message  : infoMessage,
    }


    const CountryCode = {
        type        : 'select',
        name        : 'countryCode',
        label       : 'Choose Country',
        value       : country,
        isSearchable: true,
        placeholder : 'Where are your contacts from?',
        className   : 'input-sm mb-3 text-start',
        onChange    : (selected) => {

            if (selected != null) {
                setCountry(selected)
                if (selected.value != 'mixed') {
                    setInfoMessage(`The country prefix ${selected.value} will be automatically added to the contacts you are trying to upload.`)
                } else {
                    setInfoMessage(`If the file you are uploading contains phone numbers from different countries, you have to make sure that they have the corresponding prefix. `)
                }
            }

        },
        options     : Countries
    }


    return (<div className="uploader">
        <div className="text-center">
            <img alt="upload" src={image} width={240}/>
            <h5 className="mb-0">{title}</h5>
            <p>{subtitle}</p>
            <input ref={fileRef} type="file" style={{display: 'none'}} name={name}
                onChange={(event) => {
                    handleFileChoose(event)
                }}/>
            <div className="ms-3 me-3 text-start">

                {reasons && <Row>
                    <Col sm={6}>
                        <Field {...CountryCode} />
                    </Col>
                    <Col sm={6}>
                        <Select
                            label="Reason"
                            name="id_action"
                            options={reasons}
                            isReady={isReady}
                            error={errors?.id_action}
                            placeholder="Choose a reason"
                            onChange={ev => setReason(ev.value)}
                        />
                    </Col>
                </Row>}

                {!reasons && <Field {...CountryCode} />}


            </div>
            {infoMessage && <Alert {...OptionInfo} />}
            {errors?.length > 0 && errors[0]?.message && <div className="error mb-3">{errors[0]?.message}</div>}

            <Button
                size="sm"
                color="primary"
                isReady={btnReady}
                className="mb-3"
                icon={files?.length > 0 ? 'upload' : 'plus'}
                label={files?.length > 0 ? 'Upload' : 'Choose File'}
                onClick={ev => files?.length > 0 ? handleFileUpload(ev) : handleFileChoose(ev)}
            />



        </div>
    </div>)


    const ChooseButton = {
        label    : 'Choose a file',
        icon     : <Plus/>,
        className: 'btn btn-sm icon-left btn-primary mb-5',
        onClick  : (event) => {
            handleFileChoose(event)
        }
    }


    const UploadButton = {
        label    : 'Upload file',
        icon     : <UploadCloud/>,
        className: 'btn btn-sm icon-left btn-warning mb-5',
        onClick  : (event) => {
            handleFileUpload(event)
        }
    }

    const ButtonProps = files.length > 0 ? UploadButton : ChooseButton
}



export default Uploader;